function carouselDisplay(crousleEsopt, localejson) {

  /****************************** CALCULATE GLOBAL MESSAGE POSITION ******************************/

  var marginLeftCarousel = (($(".wcs-shipping-bar").width() - $(".wcs-hd-menu-right").width()) / 2);
  var translateLeftCarousel = parseInt($(".wcs-shippingContainer").css("max-width")) / 2;
  $(".wcs-shippingContainer").css({"margin-left":marginLeftCarousel, "transform":"translate(-"+translateLeftCarousel+"px, 0)"});

  $(document).ready(function () {
    if ($(".displayContetntTime").height() > 35)
      $(".slick-cloned p").css("transform", "translate(0, 0)");
  });

  $(window).resize(function () {
    marginLeftCarousel = (($(".wcs-shipping-bar").width() - $(".wcs-hd-menu-right").width()) / 2);
    translateLeftCarousel = parseInt($(".wcs-shippingContainer").css("max-width")) / 2;
    $(".wcs-shippingContainer").css({"margin-left":marginLeftCarousel, "transform":"translate(-"+translateLeftCarousel+"px, 0)"});
    if ($(".displayContetntTime").height() > 35)
      $(".slick-cloned p").css("transform", "translate(0, 0)");
  });

  /****************************** CALCULATE GLOBAL MESSAGE POSITION ******************************/

  var espotVariable = JSON.stringify(crousleEsopt.sliders);
  var crousleSilders = jQuery.parseJSON(espotVariable);
  //All Map Information Id,CountDown,countdown_settings,translationsAlwaysOn inside list value
  var ListForCrusle = new Array();
  var ListForCountDown = new Array();
  var timeZoneDetails = new Object();
  var URLValueDetails = new Object();
  var carouselIDDetails = new Object();
  var resLocalejson = localejson.split("_");
  var updateValue = resLocalejson[0] + "-" + resLocalejson[1];
  for (var i = 0; i < crousleSilders.length; i++) {
    var IdBasisMap = {};
    IdBasisMap["id"] = crousleSilders[i].id;
    IdBasisMap["countdown"] = crousleSilders[i]["countdown"];
    IdBasisMap["countdown_settings"] = crousleSilders[i]["countdown-settings"];
    IdBasisMap["translationsAlwaysOn"] = crousleSilders[i]["translationsAlwaysOn"];
    var countDownCountry = crousleSilders[i].countdown;
    var countDownSetting = crousleSilders[i]["countdown-settings"];
    var translationsAlwaysOn = crousleSilders[i].translationsAlwaysOn;
    var timeZone = new Array();
    var countDownSettingMap = countDownSetting[0];
    timeZone.push(countDownSettingMap.anchorID);
    timeZone.push(countDownSettingMap.month);
    timeZone.push(countDownSettingMap.day);
    timeZone.push(countDownSettingMap.hour);
    timeZone.push(countDownSettingMap.timezone);
    if (countDownCountry.indexOf(updateValue) != -1) {
      timeZone.push("true");
    }
    timeZoneDetails[crousleSilders[i].id] = timeZone;


    var translationsCountdownList = countDownSettingMap.translationsCountdown;
    var translationsAlwaysOnMap = translationsAlwaysOn[0];
    var translationsAlwaysOnList = translationsAlwaysOnMap.langs;
    var translationsAlwaysOnListFinal = translationsAlwaysOnList[0];
    var translationsCountdownMap = translationsCountdownList[0];
    var carouselValueList = translationsCountdownMap.langs;
    var carouselValueMap = carouselValueList[0];
    var crouUrlList= crousleSilders[i].url;
    var crouUrlMap=crouUrlList[0];
    var crouUrlStores=crouUrlMap.stores;
    var crouUrlStoresMap = crouUrlStores[0];

    for (var carouselKey in carouselValueMap) {
      if (carouselKey == updateValue) {
        if (!isBlank(carouselValueMap[carouselKey])) {
          carouselIDDetails[crousleSilders[i].id] = carouselValueMap[carouselKey];
          URLValueDetails[crousleSilders[i].id] = crouUrlStoresMap[carouselKey];
        } else {
          carouselIDDetails[crousleSilders[i].id] = translationsAlwaysOnListFinal[carouselKey];
          URLValueDetails[crousleSilders[i].id] = crouUrlStoresMap[carouselKey];
        }
      }
    }
    ListForCrusle.push(IdBasisMap);

  }
  var varForCrousle = "<html>";
  varForCrousle += "<section class='lazy sliderCarousel globalMessageCarouselContainer' data-sizes='50vw'>";
  var lenghtOfText;
  for (var carouselID in carouselIDDetails) {
    var listvalue = timeZoneDetails[carouselID];
    var date = new Date();
    lenghtOfText = carouselIDDetails[carouselID].length;
    var sbTime = listvalue[1] + "/" + listvalue[2] + "/" + date.getFullYear(); //fixed date format fo Safari browser
    varForCrousle += "<div  class='mySlidesCarousel globalMessageCarousel'>";
    //varForCrousle +="<p class='displayContetnt'>" +carouselIDDetails[carouselID]+"</p>";
      varForCrousle += "<a  type='hidden' class='displayContetntMeasge' data-description="+crousleSilders[carouselID-1]['data-description']+" data-element-id="+crousleSilders[carouselID-1]['data-element-id']+" style='cursor: pointer;'  href="+URLValueDetails[carouselID] +" ><p id='DateTimer" + carouselID + "'  style='cursor: pointer;' class='displayContetntTime'>"+ carouselIDDetails[carouselID] +"</p>";
    varForCrousle += "<input  id='contentValue" + carouselID + "' type='hidden'  value='" + carouselIDDetails[carouselID] + "'/>";
    varForCrousle += "<input  id='isTrueForTimer" + carouselID + "' type='hidden'  value='" + listvalue[5] + "'/>";
    varForCrousle += "</a>";
    varForCrousle += "<input type='hidden' id='sbTime" + carouselID + "' value='" + sbTime + "'/>";
    varForCrousle += "</div>";
  }

  varForCrousle += "</section>";
  varForCrousle += "</html>";
  $("#CarouseldetailsId").html(varForCrousle);

  function isBlank(str) {
    return (!str || /^\s*$/.test(str));
  }

  function callSetInterval(id, datevale,contentValue,isTrueTimerValue) {
    var countDownDate = new Date(datevale).getTime();
    var distance = 0;
    var countSpace='&nbsp;&nbsp;';
    document.getElementById(id).innerHTML = contentValue + countSpace +'<span id="'+id+'_" class="changeForBold"></span>';
    var lengthOfDate=datevale.length;
    if(lengthOfDate !== 0){
     var crusleDate = setInterval(function () {
      var now = new Date().getTime();
      distance = countDownDate - now;
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      var leghtOfTimmer=days + "d: " + hours + "h: " + minutes + "m: " + seconds + "sec";
      if(isTrueTimerValue=="true"){
      document.getElementById(id+"_").innerHTML = leghtOfTimmer;
      }
    if (distance < 0) {
      clearInterval(crusleDate);
      document.getElementById(id).innerHTML = "";
      document.getElementById(id).style.width= 'auto';
      document.getElementById(id).innerHTML = contentValue
    }
     }, 1000);
  }
    else
      {
      clearInterval(crusleDate);
        document.getElementById(id).innerHTML = "";
        document.getElementById(id).style.width= 'auto';
        document.getElementById(id).innerHTML = contentValue
      }
  }

  function callSlideOnStartup() {
    var slidesDivs = document.getElementsByClassName("mySlidesCarousel");
    var carouselID =1;
    for (var i = 0; i < slidesDivs.length; i++) {
      var paragraphs = slidesDivs[i].children;
      var contentValueId=document.getElementById("contentValue"+carouselID).value;
      var isTrueForTimerValue=document.getElementById("isTrueForTimer"+carouselID).value;
      callSetInterval("DateTimer" + carouselID, paragraphs[1].value,contentValueId,isTrueForTimerValue);
      carouselID++;
    }
  }
  // Initial Call for Initialize timer in every offer
  callSlideOnStartup();
  if ($('.wcs-shippingContainer').hasClass('wcs-hide')) {
    $('.wcs-shippingContainer').removeClass('wcs-hide')
  }
  var widthRightMenu = $(".wcs-hd-menu-right").width();
  var widthTotalGlobal = $(".wcs-shipping-bar").width();
  var widthGlobalMessage = $(".wcs-shippingContainer").width();
  var widthLeftMenu = widthTotalGlobal - widthRightMenu;
  var marginleftGlobalMessage = (widthLeftMenu/2)-(widthGlobalMessage/2);
  //$('head').append('<style>@media screen and (min-width: 1496px) {.wcs-shippingContainer {left:'+marginleftGlobalMessage+'px; position:absolute;}}</style>')
}

$(window).on('load', function() {
  if ($('.carouselDisMobile #CarouseldetailsId').hasClass('wcs-hide')) {
    $('.carouselDisMobile #CarouseldetailsId').removeClass('wcs-hide')
  }

});
